// extracted by mini-css-extract-plugin
module.exports = {"bgGradient":"styles_bgGradient__9bpJ_"};